import { render } from "./ConfirmationErrorScreenView.vue?vue&type=template&id=81cc2dde"
import script from "./ConfirmationErrorScreenView.vue?vue&type=script&lang=js"
export * from "./ConfirmationErrorScreenView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__